import { getRememberLoginPref } from './rememberLogin';

const AUTH_FORM_PATHS = ['/login', '/register', '/forgot-password', '/reset-password'];

const SESSION_HINT_KEY = 'tamcare_had_session';

export function isAuthFormPath(pathname = '') {
  const path = pathname || (typeof window !== 'undefined' ? window.location?.pathname : '') || '';
  return AUTH_FORM_PATHS.includes(path);
}

export function isPublicBrowsePath(pathname = '') {
  const path = pathname || (typeof window !== 'undefined' ? window.location?.pathname : '') || '';
  if (isAuthFormPath(path)) return true;
  if (path === '/' || path === '/privacy' || path === '/terms') return true;
  if (path === '/blogs' || path.startsWith('/blogs/') || path === '/blog') return true;
  return false;
}

export function shouldAttemptSessionRestore(pathname = '') {
  return !isAuthFormPath(pathname);
}

export function shouldSkipHomepageRefresh() {
  if (typeof window === 'undefined') return false;
  const path = window.location?.pathname || '';
  if (path !== '/') return false;

  try {
    if (sessionStorage.getItem(SESSION_HINT_KEY) === '1') return false;
  } catch (_) {
    // ignore
  }

  return !getRememberLoginPref();
}

export function markSessionActive() {
  try {
    sessionStorage.setItem(SESSION_HINT_KEY, '1');
  } catch (_) {
    // ignore
  }
}

export function clearSessionHint() {
  try {
    sessionStorage.removeItem(SESSION_HINT_KEY);
  } catch (_) {
    // ignore
  }
}
